<template>
  <modal :show="isModalVisible" @close="isModalVisible = false" class="prompt-modal" :persist="true">
    <form @submit.prevent="createOpReport">
      <div class="modal-header">
        <h3 class="m-0">Is this the final report?</h3>
      </div>
      <div class="modal-body d-flex">
        <div>
          <p class="lead" style="max-width: 500px">
            If you are attaching an op report, we can send a notification to the referring office
          </p>
          <div>
            <div class="row">
              <div class="col-12" v-if="practiceDoctors.length == 0">
                <label class="d-flex"> Referring Doctor </label>
                <add-doctor
                  @added="
                    (data) => {
                      referringDoctorId = data.id
                      isAddDoctor = false
                    }
                  "
                  :showAddButton="false"
                  v-model="referringDoctorId"
                  name="referring_doctor_id"
                  ref="addDoctorForm"
                />
              </div>
              <div class="col-12" v-if="practiceDoctors.length > 1">
                <label class="d-flex">
                  Referring Doctor
                  <small class="ml-auto">
                    <!-- <a href="javascript:void(0)" @click="isAddDoctor = !isAddDoctor" class="font-weight-bolder">{{
                      !isAddDoctor ? '+ Add doctor' : 'Cancel'
                    }}</a> -->
                  </small>
                </label>
                <select
                  v-if="!isAddDoctor"
                  class="form-control form-control-lg form-control-xl"
                  v-model="referringDoctorId"
                  name="referring_doctor_id"
                  v-validate="'required'"
                  data-vv-scope="referral-form"
                  data-vv-as="Referred From"
                  :key="practiceDoctors.map((s) => s.id).join('')"
                >
                  <option v-if="practiceDoctors.length === 0" disabled value>No Doctors Available</option>
                  <option v-else-if="practiceDoctors.length > 1" disabled :value="null" hidden>- Select -</option>
                  <option v-for="d in practiceDoctors" :value="d.id" :key="d.id">
                    {{ $helpers.displayUsername(d) }}
                  </option>
                </select>
                <span v-if="errors.has('referring_doctor_id', 'referral-form')" class="invalid-feedback d-block">{{
                  errors.first('referring_doctor_id', 'referral-form')
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-lg btn-xl btn-primary btn-block m-0" :disabled="isSubmitting">
          <font-awesome-icon icon="spinner-third" v-if="isSubmitting" spin />
          <span>Send final report</span>
        </button>
        <a href="javascript:;" class="btn btn-link btn-block font-weight-bolder mr-3" @click="$emit('close')"
          >No, I don't want to send this</a
        >
      </div>
    </form>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { mapState } from 'vuex'
import AddDoctor from '../AddDoctor.vue'
export default {
  components: { Modal, AddDoctor },
  props: {
    item: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isModalVisible: true,
      isSubmitting: false,
      isAddDoctor: false,
      practice: { ...this.$store.state.auth.user.practice },
      referringDoctorId: null,
      btnEditText: "Now it's correct!",
    }
  },
  computed: {
    ...mapState('auth', ['user', 'token', 'error']),
    practiceDoctors() {
      return this.user.practice.doctors
    },
  },
  mounted() {
    // let's get the referring doctor id

    // if only one doctor
    // if it's not Any (First Available) then we can do a string comparison match on current doctors

    if (this.practiceDoctors.length === 1) {
      this.referringDoctorId = this.practiceDoctors[0].id
    } else {
      if (this.user.is_doctor) {
        this.referringDoctorId = this.user.id
      }
    }
  },
  methods: {
    async createOpReport(e) {
      if (this.practiceDoctors.length == 0 && this.$refs.addDoctorForm) {
        const isDoctorAdded = await this.$refs.addDoctorForm.addNewDoctor(e)
        if (!isDoctorAdded) return
      }
      this.$emit('send', this.referringDoctorId)
    },
  },
}
</script>
<style scoped lang="scss">
.prompt-modal .modal-container {
  width: 100%;
}
@media (min-width: 576px) {
  .prompt-modal .modal-container {
    width: 550px;
  }
}
</style>
